import styled from 'styled-components';

export const InputWrapper = styled.div`
  margin-bottom: 16px;
`;

export const InputSection = styled.div`
  margin-bottom: 32px;
`;
